import { useEffect } from "react";
import { registrarInteracao, zerarTitulo } from "@/lib/avisos/tituloDaAba";

/** Liga o contador do título (parte D1) às interações da pessoa. Montado no NotificationProvider. */
export function useTituloDaAba(): void {
  useEffect(() => {
    const aoInteragir = () => registrarInteracao();
    window.addEventListener("pointerdown", aoInteragir, true);
    window.addEventListener("keydown", aoInteragir, true);
    return () => {
      window.removeEventListener("pointerdown", aoInteragir, true);
      window.removeEventListener("keydown", aoInteragir, true);
      zerarTitulo();
    };
  }, []);
}
